import {useEffect, useState} from 'react';

export default ({timeout_key, cooldown_timestamp, hoursOnly, children}) => {
    const [timestamp, setTimestamp] = useState(cooldown_timestamp);
    const [time, setTime] = useState(timestamp - Date.now());

    useEffect(() => {
        setTimestamp(cooldown_timestamp);
        setTime(cooldown_timestamp - Date.now());
    }, [cooldown_timestamp])

    useEffect(() => {
        if(time < 0)
            return;

        if(typeof window.cooldownBlocksTimeout === "undefined")
            window.cooldownBlocksTimeout = {};

        window.cooldownBlocksTimeout[timeout_key] = setTimeout(() => {
            setTime(timestamp - Date.now());
        }, 500);
        return () => window.clearTimeout(window.cooldownBlocksTimeout[timeout_key]);
    }, [time]);

    const format = t => {
        const days = !hoursOnly ? Math.floor(t / (24 * 60 * 60 * 1e3)) : 0;
        t -= days * (24 * 60 * 60 * 1e3);
        const hours = Math.floor(t / (60 * 60 * 1e3));
        t -= hours * (60 * 60 * 1e3);
        const minutes = Math.floor(t / (60e3));
        t -= minutes * 60e3;
        const seconds = Math.floor(t / 1e3);

        return {
            days: days < 10 ? `0${days}` : days,
            hours: hours < 10 ? `0${hours}` : hours,
            minutes: minutes < 10 ? `0${minutes}` : minutes,
            seconds: seconds < 10 ? `0${seconds}` : seconds
        }
    }

    const formatted_time = format(time);

    if(time > 0) 
        return ( 
            <div className="bonus-information-bottom">
                <div className="bonus-cooldown">
                    {!hoursOnly ? (
                        <div className="section">
                            <div className="value">{formatted_time.days}</div>
                            <span>days</span>
                        </div>
                    ) : <></>}
                    <div className="section">
                        <div className="value">{formatted_time.hours}</div>
                        <span>hours</span>
                    </div>
                    <div className="section">
                        <div className="value">{formatted_time.minutes}</div>
                        <span>minutes</span>
                    </div>
                    {hoursOnly ? (
                        <div className="section">
                            <div className="value">{formatted_time.seconds}</div>
                            <span>seconds</span>
                        </div>
                    ) : <></>}
                </div>
            </div>
        )

    return children;
}